import React, { FunctionComponent, useContext } from 'react';

import { PageContext, PageContextProps } from "/src/contexts/Page";
import { ChallengeRatingData } from "/src/domain/challenges/ChallengeRatingData"
import { User } from "/src/domain/shared/User";

import { RatingProvider } from "/src/contexts/RatingContext"

import { Header } from "/src/ui/shared/header";
import { Footer } from "/src/ui/shared/footer";
import { UpcomingRacesContainer } from "/src/ui/shared/upcomingRaces/index"
import RatingHeader from "/src/ui/challengeRating/RatingHeader"
import Ratings from "/src/ui/challengeRating/Ratings"
import { ThemeProvider, StyledEngineProvider, GlobalStyles } from '@mui/material';
import { makeStyles, ThemeProvider as ThemeProviderForStyles } from '@mui/styles';
import theme from '/src/ui/shared/styledTheme'
import { theme as themeColor } from '/src/assets/theme';

const ChallengeRatingApp: FunctionComponent = () => {
    const { pageData, currentUser } = useContext(PageContext) as PageContextProps;

    if (pageData === null) return null;

    const challengeRating = pageData as ChallengeRatingData;
    return <StyledEngineProvider injectFirst>
        <GlobalStyles
            styles={{
                'body': {
                    backgroundColor: themeColor.WHITE_COLOR,
                },
            }}
        />
        <ThemeProvider theme={theme}>
            <ThemeProviderForStyles theme={theme}>
                <RatingProvider>
                    <App
                        challengeRating={challengeRating}
                        currentUser={currentUser}
                    />
                </RatingProvider>
            </ThemeProviderForStyles>
        </ThemeProvider>
    </StyledEngineProvider>;
}

interface AppProps {
    challengeRating: ChallengeRatingData;
    currentUser?: User;
}

const App: FunctionComponent<AppProps> = ({
    challengeRating,
    currentUser
}) => {
    const classes = useStyles()

    return <>
        <Header currentUser={currentUser} />
        <div className={classes.contentContainer}>
            <UpcomingRacesContainer organization={challengeRating.seasons[0]?.organization} withHeader={false}/>
            <RatingHeader
                partners={challengeRating.partners}
            />
            <Ratings 
                challengeRating={challengeRating}
                currentUserId={currentUser?.id}
            />
        </div>
        <Footer />
    </>;
}

const useStyles = makeStyles((theme) => ({ 
    contentContainer: {
        [theme.breakpoints.up("sm")]: {
            maxWidth: "1100px",
            margin: "0 auto"
        },
        paddingTop: "1.5rem"
    }
}))

export default ChallengeRatingApp